<template>
  <div>
    <div v-if="isEditing">
      <textarea rows="4" v-model="newNotes"></textarea>
      <br>
      <a href="#" class="btn-xs btn-primary" @click.prevent="save">{{ isSaving ? 'saving' : 'save' }}</a>
      <span>|</span>
      <a href="#" class="btn-xs btn-default" @click.prevent="cancel">cancel</a>
    </div>
    <div v-else>
      <div>{{ oldNotes }}</div>
      <a href="#" class="btn-xs btn-default" @click.prevent="edit">edit</a>
    </div>
  </div>
</template>

<script>
import { updateOrder } from '../../../api';
export default {
  name: 'tdOrderNotes',
  props: ['row'],
  data() {
    return {
      oldNotes: this.row.orderNotes,
      newNotes: this.row.orderNotes,
      isEditing: false,
      isSaving: false,
    }
  },
  watch: {
    'row.orderNotes': {
      handler(value) {
        this.oldNotes = value;
        this.newNotes = value;
      },
      deep: true
    }
  },
  methods: {
    edit() {
      this.isEditing = true;
    },
    cancel() {
      if (this.isSaving) {
        return;
      }

      this.newNotes = this.oldNotes;
      this.isEditing = false;
    },
    async save() {
      if (this.isSaving) {
        return;
      }

      if (this.newNotes === this.oldNotes) {
        this.isEditing = false;
        return;
      }

      this.isSaving = true;

      const { success, message } = await updateOrder(this.row.skId, {
        notes: this.newNotes
      });

      if (success) {
        this.oldNotes = this.newNotes
      } else {
        this.newNotes = this.oldNotes
      }

      this.isEditing = false;
      this.isSaving = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdOrderNotes.vue